/**
 * safari doesn't support dateTime's with a space in between the date and time for example.
 */
const parseDateTime = (dateTime: string | Date) =>
    typeof dateTime === 'string' ? new Date(dateTime.replace(/-/g, '/')) : dateTime;
export default parseDateTime;
